export type PasswordTone = 'none' | 'weak' | 'medium' | 'strong';

export interface PasswordCheck {
  ok: boolean;
  score: 0 | 1 | 2 | 3;
  label: '' | 'Fraca' | 'Média' | 'Forte';
  tone: PasswordTone;
  hints: string[];
  rules: { label: string; passed: boolean }[];
}

const COMMON_PASSWORDS = new Set([
  '12345678', '123456789', '1234567890', '11111111', '00000000',
  'password', 'password1', 'password123', 'senha1234', 'senha12345',
  'qwerty123', 'qwerty1234', 'abc12345', 'abcd1234', 'iloveyou',
  'admin1234', 'letmein123', 'welcome123', 'futebol12', 'futebol123',
  'brasil123', 'brasil1234', 'corinthians', 'flamengo123',
]);

export function checkPassword(password: string, email: string = ''): PasswordCheck {
  const rulesEmpty = [
    { label: 'Pelo menos 10 caracteres', passed: false },
    { label: '14+ caracteres OU mistura de 3 tipos (a-z, A-Z, 0-9, símbolo)', passed: false },
  ];

  if (password.length === 0) {
    return { ok: false, score: 0, label: '', tone: 'none', hints: [], rules: rulesEmpty };
  }

  const len = password.length;
  const lower = password.toLowerCase();
  const hasLower = /[a-z]/.test(password);
  const hasUpper = /[A-Z]/.test(password);
  const hasNumber = /[0-9]/.test(password);
  const hasSpecial = /[^a-zA-Z0-9]/.test(password);
  const categories = [hasLower, hasUpper, hasNumber, hasSpecial].filter(Boolean).length;

  const minLengthOk = len >= 10;
  const longPassphrase = len >= 14;
  const enoughVariety = len >= 10 && categories >= 3;
  const strongRule = longPassphrase || enoughVariety;

  const isCommon = COMMON_PASSWORDS.has(lower);
  let containsEmail = false;
  if (email) {
    const emailLocal = email.split('@')[0].toLowerCase();
    if (emailLocal.length >= 4 && lower.includes(emailLocal)) containsEmail = true;
  }

  const hints: string[] = [];
  if (isCommon) hints.push('Essa senha é muito comum, escolhe outra.');
  if (containsEmail) hints.push('Não usa seu e-mail dentro da senha.');

  let score: PasswordCheck['score'];
  let label: PasswordCheck['label'];
  let tone: PasswordTone;

  if (isCommon || containsEmail || !minLengthOk) {
    score = 1; label = 'Fraca'; tone = 'weak';
  } else if (!strongRule) {
    score = 2; label = 'Média'; tone = 'medium';
  } else {
    score = 3; label = 'Forte'; tone = 'strong';
  }

  const rules = [
    { label: 'Pelo menos 10 caracteres', passed: minLengthOk },
    { label: '14+ caracteres OU mistura de 3 tipos (a-z, A-Z, 0-9, símbolo)', passed: strongRule },
  ];

  return { ok: score === 3, score, label, tone, hints, rules };
}
